'use client';

import React from 'react';
import { AuthProvider } from '@/contexts/AuthContext';
import { ThemeProvider } from '@/contexts/ThemeContext';
import AmplifyConfig from './AmplifyConfig';
import PullToRefresh from './ui/PullToRefresh';

export default function ClientProviders({ children }: { children: React.ReactNode }) {
    return (
        <>
            <AmplifyConfig />
            <ThemeProvider>
                <AuthProvider>
                    <PullToRefresh>
                        {children}
                    </PullToRefresh>
                </AuthProvider>
            </ThemeProvider>
        </>
    );
}
